import { BookkeepingEmailModal } from "bookkeeping/emails/BookkeepingEmailModal";
import { PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";
import SubLabel from "components/Atoms/Sublabel";
import TextLinkButton from "components/buttons/TextLinkButton";
import DeleteDialog from "components/deleteDialog";
import PanelSegment from "components/panels/PanelSegment/PanelSegment";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import Table from "components/Tables/Table";
import React from "react";

interface Props {
  bookkeepingId: number;
  emails: server.dto.BookkeepingEmail[];
  onChanged: () => Promise<void>;
}

type ModalState = { mode: "add" } | { mode: "edit"; email: server.dto.BookkeepingEmail };

export const BookkeepingEmailsPanel = (props: Props) => {
  const [modalState, setModalState] = React.useState<ModalState>(null);
  const [deletingEmail, setDeletingEmail] = React.useState<server.dto.BookkeepingEmail>(null);

  const removeEmail = async () => {
    await window.CoreApi.Bookkeeping.RemoveEmail({
      bookkeepingId: props.bookkeepingId,
      email: deletingEmail.email,
    });
    setDeletingEmail(null);
    await props.onChanged();
  };

  const onSaved = async () => {
    await props.onChanged();
  };

  return <>
    <SectionPanel.Panel
      header={<>
        <PanelSegment.Title title={RESX.Invoice.SendToAccountingSoftware} />
        <PanelSegment.Button
          label={RESX.Buttons.Add}
          type="secondary"
          onClick={() => setModalState({ mode: "add" })}
        />
      </>}
    >
      <Table<server.dto.BookkeepingEmail>
        variant="cards"
        hideHeader
        hideNoDataAvailableDiv
        items={props.emails}
        isLoading={false}
        getKey={item => item.email}
        columns={[{
          key: "email",
          header: "",
          size: "1fr",
          render: (item) => {
            const setting = serverReference.bookkeepingEmailInvoiceSettings.find(s => s.value === item.invoiceSetting);
            return <div className="flex-column gap-mini">
              <div>
                <TextLinkButton
                  style={{ padding: 0 }}
                  onClick={() => setModalState({ mode: "edit", email: item })}
                >
                  
                  {item.email}
                </TextLinkButton>
              </div>
              {<SubLabel>{setting.text}</SubLabel>}
            </div>;
          },
        }, {
          key: "actions",
          header: "",
          size: "auto",
          align: "right",
          render: (item) => <PhosphorTrashButton
            layout="in-square"
            onClick={() => setDeletingEmail(item)}
          />,
        }]}
      />
    </SectionPanel.Panel>

    {modalState != null && <BookkeepingEmailModal
      bookkeepingId={props.bookkeepingId}
      initialEmail={modalState.mode === "edit" ? modalState.email : null}
      onClose={() => setModalState(null)}
      onSaved={onSaved}
    />}

    <DeleteDialog
      isOpen={deletingEmail != null}
      message={RESX.GeneralWarnings.AreYouSure}
      handleClose={() => setDeletingEmail(null)}
      onDelete={removeEmail}
    />
  </>;
};
